export default "<input (keydown)=\"onKeyPress($event)\" type=\"text\" #inputLabel autofocus>\r\n<div class=\"click-exit\" (click)=\"hide()\"></div>\r\n\r\n"